import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import styles from '../myOrders.module.scss';

const DesktopQuotes = ({ orders }) => {
  const navigate = useNavigate();

  const columns = [
    { name: 'Comercio', size: 'large' },
    { name: 'Estado', size: 'large' },
    { name: 'Fecha', size: 'large' },
    { name: 'Cotización', size: 'large' },
  ];

  return (
    <div className={styles['desktop-orders-container']}>
      <div className={`${styles.row} ${styles['header-row']}`}>
        {columns.map((column, i) => (
          <div key={i} className={`${styles.column} ${styles[column.size]}`}>
            {column.name}
          </div>
        ))}
      </div>

      {orders.map((order, i) => (
        <div
          key={`${i}_${order.id}`}
          className={`${styles.row} ${styles['order-row']}`}
          data-status={order.status}
          onClick={() => navigate(`/cotizaciones/detalle_cotizacion/${order.code}`)}
        >
          <div className={`${styles.column} ${styles.large}`} style={{ fontWeight: 600, color: '#0f1a12' }}>
            {order.anonymousRestaurant ? 'Anónimo' : order.nameRestaurant}
          </div>
          <div className={`${styles.column} ${styles.large}`}>
            <label className={`${styles.label} ${styles[order.status]}`}>
              {order.status}
            </label>
          </div>
          <div className={`${styles.column} ${styles.large}`} style={{ color: '#9a9a94', fontSize: 13 }}>
            {moment(order.createdAt).format('DD MMM YYYY')}
          </div>
          <div className={`${styles.column} ${styles.large}`}>
            <span style={{ fontFamily: "'SF Mono','Fira Code',monospace", fontSize: 11, color: '#aaa', background: '#f4f4f2', padding: '3px 8px', borderRadius: 6, letterSpacing: '0.4px' }}>
              {order.code}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

DesktopQuotes.propTypes = {
  orders: PropTypes.array.isRequired,
};

export default DesktopQuotes;
